import {ApiService} from "./ApiService";
import sha256 from "crypto-js/sha256";

export const SystemApi = {

    authList() {
        return ApiService.get("/api/v1/admin/system/app_auth/list")
    },

    newAuth(name, password) {
        let pwd = sha256(password).toString();
        pwd = sha256(pwd).toString()
        return ApiService.post("/api/v1/admin/system/app_auth", {
            name: name,
            password: pwd
        })
    },

    removeAuth(id, password) {
        let pwd = sha256(password).toString();
        pwd = sha256(pwd).toString()
        return ApiService.delete("/api/v1/admin/system/app_auth", {
            id: id,
            password: pwd
        })
    }
}